import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import Button from '../components/common/Button'
import Input from '../components/common/Input'
import toast from 'react-hot-toast'

// PIN sign-in used to sit alongside this as a second tab with a keypad. It has
// been removed: the PIN was matched against every user at once rather than
// against a named account, so it was the whole credential and a correct guess
// signed you in as whoever owned it. Username and password is the only way in.

export default function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  const handlePasswordLogin = async (e) => {
    e.preventDefault()
    setLoading(true)

    const result = await login(username, password)

    if (result.success) {
      toast.success('Welcome back!')
      navigate('/')
    } else {
      toast.error(result.message)
    }

    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-rdi-blue to-rdi-blue-light flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="bg-rdi-blue p-6 text-center">
          <img
            src="/api/company-settings/logo/left"
            alt="Company Logo"
            className="h-12 mx-auto mb-2"
          />
          <h1 className="text-white text-xl font-semibold">Timesheet System</h1>
        </div>

        {/* Login Form */}
        <div className="p-6">
          <form onSubmit={handlePasswordLogin}>
            <Input
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <Button
              type="submit"
              block
              loading={loading}
              className="mt-4"
            >
              Sign In
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
